<template>
  <tr role="row">
    <th/>
    <th>
      <engraved-id :raw-engraved-id="filterValues.engravedId"
                   @input="value => onFilterFieldInput('engravedId', value)"/>
    </th>
    <th>
      <input :value="filterValues.cardHolderDetails"
             class="filter"
             @input="$event => onFilterFieldInput('cardHolderDetails', $event.target.value)">
    </th>
    <th>
      <input :value="filterValues.combinedAscriptions"
             class="filter"
             @input="$event => onFilterFieldInput('combinedAscriptions', $event.target.value)">
    </th>
    <th>
      <input :value="filterValues.validUntil"
             class="filter"
             @input="$event => onFilterFieldInput('validUntil', $event.target.value)">
    </th>
  </tr>
</template>

<script>
import {buildFilterPair} from '../../types/filter-pair'
import EngravedId from '../tableHeaderSearch/fields/EngravedId'

export default {
  name: 'OrderReplacementCardTableHeaderFilter',
  components: {
    EngravedId
  },
  props: {
    filterValues: {
      type: Object,
      required: true
    }
  },
  methods: {
    onFilterFieldInput (column, value) {
      this.$emit('filteringChanged', buildFilterPair(column, value))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/orderReplacementCard/OrderReplacementCardTableHeaderFilter.vue